import CommonAppbar from '../components/common/CommonAppbar';
import {useParams} from 'react-router-dom';
import Filters from '../components/Filters';
import QuestionCard from '../components/QuesAndAns/QuestionCard';
import {useEffect} from 'react';

export default function CategoryPage() {
  let {categoryId} = useParams();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [categoryId])
  return <>
    <CommonAppbar isMainPage={false} pageHeader={categoryId}/>
    <Filters/>
    <QuestionCard/>
  </>
}
